import { useCallback, useState } from "react";
import ReportConfigurationTableComponent from "./report-configuration-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getReportConfigurations } from "../../../../../core/api/services/report.configaration.service";

const ReportConfigurationComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [reportConfigSearchValue, setReportConfigSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("reportName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Report Name",
      label: "reportName",
      isSorted: true,
      // width: "8rem"
    },
    {
      title: "Address",
      label: "address",
    },
    {
      title: "Report Type",
      label: "reportType",
      // width: "8rem"
    },
    {
      title: "Generate Report",
      label: "generateType",
      // width: "10rem"
    },
  ]);

  const {
    data: reportConfigurations,
    isLoading: isLoadingReportConfigurations,
    refetch,
  } = useQuery({
    queryKey: [
      "getReportConfigurations",
      PageNumber,
      SortBy,
      SortDirection,
      reportConfigSearchValue,
    ],
    queryFn: ({ signal }) =>
      getReportConfigurations(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        reportConfigSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (reportConfigurations?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setReportConfigSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <ReportConfigurationTableComponent
        columns={columns}
        data={reportConfigurations?.data}
        totalNumberOfRecords={reportConfigurations?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingReportConfigurations}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default ReportConfigurationComponent;
